import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
// import classnames from 'classnames';
import _ from 'lodash'

import FormattedNumber from '../../../../../../../../../../../components/FormattedNumber'

import './style.scss'
import Counter from '../../../../../../../../../../../components/Counter'

export default class Summary extends Component {
    static propTypes = {
        data: PropTypes.object,
        translates: PropTypes.shape({
            summaryAmountText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            summaryCountText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    render() {
        const { data, translates } = this.props

        return (
            <div className={'inspections-summary-container'}>
                <div className={'inspections-counts-container'}>
                    <Counter
                        leftValue={{
                            value: _.isNil(_.get(data, 'actualCount')) ? '0' : _.get(data, 'actualCount'),
                        }}
                        separator={'/'}
                        rightValue={{
                            value: _.isNil(_.get(data, 'totalCount')) ? '0' : _.get(data, 'totalCount'),
                        }}
                        description={_.get(translates, 'summaryCountText', '')}
                        twoValues
                    />
                    <div className={'inspections-amount'}>
                        <div className={'values'}>
                            <FormattedNumber
                                displayUnits
                                displayCurrency
                                value={_.isNil(_.get(data, 'totalAmount')) ? 0 : _.get(data, 'totalAmount', 0)}
                                valueStyle={{
                                    fontFamily: '"Trivia Sans Black", sans-serif',
                                    fontWeight: '700',
                                    paddingRight: '4px',
                                }}
                                currency={data?.currency || 'CZK'}
                                currencyStyle={{
                                    fontFamily: '"Trivia Sans Light", sans-serif',
                                    fontSize: '35px',
                                    lineHeight: '35px',
                                }}
                                unitsStyle={{
                                    fontFamily: '"Trivia Sans Light", sans-serif',
                                    fontSize: '35px',
                                    lineHeight: '35px',
                                }}
                            />
                        </div>
                        <div className={'text'}>
                            <span>{_.get(translates, 'summaryAmountText', '')}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
